import { Timestamp, addDoc, collection } from 'firebase/firestore';
import { FirestoreDB } from '../../../utils/firebase/firebase';
import { ACM } from '../../../constants/UserRoles';

const useUploadNotifications = () => {
  // Add video upload notifications
  const addVideoNotification = async (videoID, selectedUserId, user, typeOfUser, patientData, students, teacherData) => {
    try {
      let recipientsToNotify = [];

      if (ACM[typeOfUser]?.isPatient) {
        // Patient uploaded video - notify their doctors AND teachers
        const doctors = user?.doctorDetails || [];
        const teacherList = user?.teacherDetails || [];

        recipientsToNotify = [
          // Notify all doctors
          ...doctors.map((doctor) => ({
            id: doctor.doctorId,
            email: doctor.email,
            notificationSource: 'uploadVideo',
          })),
          // Notify all teachers
          ...teacherList.map((teacher) => ({
            id: teacher.teacherId || teacher.id,
            email: teacher.email,
            notificationSource: 'uploadVideo',
          })),
        ];
      } else if (ACM[typeOfUser]?.isStudent) {
        // Student uploaded video - notify their teachers using hook data
        // Students don't have teacherDetails in user object, so use teacherData from hook

        recipientsToNotify = [
          // Notify all teachers from hook data
          ...teacherData.map((teacher) => ({
            id: teacher.id,
            email: teacher.email,
            notificationSource: 'uploadVideo',
          })),
        ];
      } else if (ACM[typeOfUser]?.isDoctor) {
        // Doctor uploaded video - notify the selected patient AND their teachers
        const patientDetails = patientData.find(
          (each) =>
            each?.patientId === selectedUserId ||
            each?.id === selectedUserId ||
            each?.uid === selectedUserId
        );

        if (patientDetails) {
          recipientsToNotify = [
            // Notify the patient
            {
              id: selectedUserId,
              email: patientDetails.patientInfo?.email || patientDetails.email,
              notificationSource: 'uploadVideo',
            },
          ];

          // Also notify patient's teachers if they have any
          const patientTeachers = patientDetails.teacherDetails || [];
          recipientsToNotify.push(
            ...patientTeachers.map((teacher) => ({
              id: teacher.teacherId || teacher.id,
              email: teacher.email,
              notificationSource: 'uploadVideo',
            }))
          );
        } else {
          console.log(
            'DEBUG VIDEO DOCTOR: Patient not found in patientData array'
          );
        }
      } else if (ACM[typeOfUser]?.isTeacher) {
        // Teacher uploaded video - notify the selected student AND their doctors
        const studentDetails = students.find(
          (each) => each.id === selectedUserId
        );
        if (studentDetails) {
          recipientsToNotify = [
            // Notify the student
            {
              id: selectedUserId,
              email: studentDetails.email,
              notificationSource: 'uploadVideo',
            },
          ];

          // Also notify student's doctors if they have any
          const studentDoctors = studentDetails.doctorDetails || [];
          recipientsToNotify.push(
            ...studentDoctors.map((doctor) => ({
              id: doctor.doctorId,
              email: doctor.email,
              notificationSource: 'uploadVideo',
            }))
          );
        }
      }

      // Send notifications to all recipients
      for (const recipient of recipientsToNotify) {
        if (recipient.email && recipient.id) {
          const params = {
            title: `${typeOfUser} uploaded a new video`,
            description: '',
            notifyTo: recipient.email,
            sentBy: user?.email,
            userName: user?.fullname,
            userPhotoURL: user?.photoURL,
            videoID: videoID,
          };

          await addDoc(
            collection(FirestoreDB, 'notifications', recipient.id, 'messages'),
            {
              infoMessage: btoa(JSON.stringify(params)),
              notificationSource: recipient.notificationSource,
              userId: user?.uid,
              isEncrypted: false,
              readStatus: false,
              createdDate: Timestamp.now(),
            }
          );
        }
      }
    } catch (e) {
      console.log('Error while adding video notification', e);
    }
  };

  return {
    addVideoNotification,
  };
};

export default useUploadNotifications;
